<template>
    <b-row class="h-100 w-100">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>     

        <b-col class="col-10" v-if="!thereIsNoData">
            <apexchart v-if="series" id="chart" style="flex:1;"
            width="100%" height="85%" ref="apexchart" 
            :options="chartOptions" 
                :series="series" />
        </b-col>
        <b-col class='col-2 d-flex align-items-center' v-if="isFlexible && !thereIsNoData">
            <table class="table table-bordered" style="width: 90%; height:80%; margin-left:auto; margin-right:auto;">
                <thead>
                    <tr class="text-center table-dark">
                    <th v-for="(item, index) in flexableGraphTableData">
                    {{ index }}
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(header, index) in flexableGraphTableData.index" :key="index">
                    <td class="text-center">{{ header }}</td>
                    <td class="text-right" v-for="(value, dataIndex) in flexableGraphTableData" v-if="dataIndex !== 'index'" :key="dataIndex">
                        {{ value[index] }}
                    </td>
                    </tr>
                </tbody>
            </table>
        </b-col>
    </b-row>
    
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray} from '@/components/chatter/util/graphUtils';
import {BIcon} from 'bootstrap-vue'
export default {
    name: 'ProgramTestDistributionGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        BIcon
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.testCaseData = this.dashboardData.testCase;

        if(this.testCaseData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            loading:false,
            thereIsNoData : false,
            testCaseData : [],
            series: [],
            dateRange : [],
            flexableGraphTableData : '',
            chartOptions: {
                chart: {
                    height:'80%',
                    type: "heatmap",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                // markers: {
                //     size: false
                // },
                dataLabels: {
                    enabled: false, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors:['#9BE9A8'], // 데이터 라벨의 색상을 지정합니다.
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -9, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#fff',
                        padding: 4,
                        borderRadius: 4,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 0.8,
                    }
                },
                tooltip: {
                    enabled:true,
                    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    // 마우스 오버 툴팁 레이블을 사용자 지정합니다.
                    return '<div style="background-color : #333; color: #fff; border-radius: 5px; padding : 10px; font-size : 14px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);">' +
                        'Program ID : ' + w.globals.initialSeries[seriesIndex].data[dataPointIndex][2] + '<br>' +
                        'Count : ' + w.globals.initialSeries[seriesIndex].data[dataPointIndex][1] + '<br></div>';
                    },
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                colors:['#9BE9A8'],
                xaxis: {
                    // categories: [],
                    show:false,
                    labels: {
                        show:false
                    }
                },
                yaxis: {
                    labels: {
                        show:false
                    }
                },
                legend: {
                    show : this.isFlexible
                },
                plotOptions: {
                    heatmap: {
                        shadeIntensity: 0.6,
                        radius: 0,
                        distributed:true,
                        useFillColorAsStroke: true,
                        colorScale: {
                            // inverse:true,
                            labels: {
                                show:false
                            },
                            ranges: [{
                                    from: 0,
                                    to: 0,
                                    name: '0',
                                    color: '#a9a9a9'
                                },
                                {
                                    from: 1,
                                    to: 1,
                                    name: '1',
                                    color: '#50abe4'
                                },
                                {
                                    from: 2,
                                    to: 2,
                                    name: '2',
                                    color: '#00bfff'
                                },
                                {
                                    from: 3,
                                    to: 3,
                                    name: '3',
                                    color: '#1e90ff'
                                },
                                {
                                    from: 4,
                                    to: 4,
                                    name: '4',
                                    color: '#0000cd'
                                },
                                {
                                    from: 5,
                                    to: 60,
                                    name: '5+',
                                    color: '#0000ff'
                                },
                            ]
                        }
                    }
                },
            },
        }
    },
    methods: {

        getAllAlternativeId() {
            let altIdArray = [];
            let historyDataArray = this.dashboardData.history;
            
            historyDataArray.forEach(data => {
                if(data.alternativeId != '') {
                    altIdArray.push(data.alternativeId);
                }
            });

            return [...new Set(altIdArray)];
        },

        visualizeGraph() {
            let testData = this.testCaseData;

            if(this.isFlexible) {
                let round = this.filters.Round;

                // None 값을 ""로 변경
                round = round.map(value => value === "None" ? "" : value);

                testData = testData.filter(item => {
                    return (
                        round.includes(item.round)
                    );
                });
            }
            
            let allAlternativeIdArray = this.getAllAlternativeId();
            let altIdCountObject = {}
            let tableData = {                 
                "index": [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5+",
                    "Total",
                    "진행률"
                ],
                "Count": [0, 0, 0, 0, 0, 0, 0, 0],
            }

            allAlternativeIdArray.forEach(id => {
                altIdCountObject[id] = 0;
            })
            
            let total = 0;
            testData.forEach(testObj => {
                if(altIdCountObject[testObj.alternativeId] !== undefined) {
                    altIdCountObject[testObj.alternativeId]++;
                }
            });

            let series = [];
            let tempArray = [];
            let idx = 0;
            let square = Math.ceil(Math.sqrt(allAlternativeIdArray.length));

            allAlternativeIdArray.forEach(id => {
                let data = [idx, altIdCountObject[id], id];
                tempArray.push(data);
                total += altIdCountObject[id];
                idx++;
                if(idx == square) {
                    series.push({
                        data:tempArray
                    });
                    tempArray = []
                    idx = 0;
                }
                

                switch (altIdCountObject[id]) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        tableData['Count'][altIdCountObject[id]]++;
                        break;
                    default:
                        tableData['Count'][5]++;
                }
                tableData['Count'][6]++;
            });
            let actualCount = 0;
            for(let i = 1; i < 6; i++) {
                actualCount += tableData['Count'][i];
            }

            tableData['Count'][7] = (actualCount / tableData['Count'][6] * 100).toFixed(2) + '%';
            
            this.flexableGraphTableData = tableData;
            
            this.series = series;
            this.label = new Array(77).fill(0);
            this.setLabels();

        },
        getAllAlternativeId() {
            let altIdArray = [];
            let historyDataArray = this.dashboardData.history;
            
            historyDataArray.forEach(data => {
                
                if(data.alternativeId != '') {
                    altIdArray.push(data.alternativeId);
                }
            });
            return [...new Set(altIdArray)];
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    xaxis: {
                        categories: this.label,
                    },
                });
            }
        },
        setTable() {
            this.tableData = this.data.table;

        }
    },
}
</script>
<style scoped>
/* 기본 툴팁 스타일 */
.custom-tooltip {
  background: rgba(0, 0, 0, 0.8); /* 배경색 */
  color: #fff; /* 글자색 */
  border-radius: 5px; /* 테두리 둥글기 */
  padding: 10px; /* 내부 여백 */
  font-size: 14px; /* 글자 크기 */
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5); /* 그림자 효과 */
}

/* 툴팁 화살표 스타일 */
.custom-tooltip::before {
  border-bottom: 8px solid rgba(0, 0, 0, 0.8); /* 화살표 아래 테두리색 */
  border-left: 8px solid transparent; /* 화살표 왼쪽 테두리색 */
  border-right: 8px solid transparent; /* 화살표 오른쪽 테두리색 */
  content: ""; /* 내용 없음 */
  position: absolute;
  bottom: -8px; /* 화살표 위치 조절 */
  left: 50%; /* 가운데 정렬 */
  transform: translateX(-50%); /* 가운데 정렬을 위한 위치 이동 */
}
</style>
